<!-- A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review. -->
<script>
  import Tabs from "$lib/components/Tabs/Tabs.svelte";
  import Chart from "$lib/components/Chart/Chart.svelte";
  import Map from "$lib/components/Map/Map.svelte";
  import { Block } from "@urbaninstitute/dataviz-components";
  import { createToolData } from "$utils/data.svelte.js";
  import { onMount } from "svelte";
  import { TOOL_TITLE } from "$utils/consts.js";

  const toolData = createToolData();

  onMount(() => {
    toolData.fetchChartData(toolData.activeGeo);
  });

  // Fetch new chart data when geography changes
  $effect(() => {
    const geo = toolData.activeGeo;
    toolData.fetchChartData(geo);
  });

  // Fetch map data on demand when map tab is activated, and when frequency changes
  $effect(() => {
    if (toolData.mapDataNeeded) {
      const freq = toolData.getMapFrequency();
      toolData.fetchMapData(freq);
    }
  });
</script>

<Block>
  <h4 class="tool-subhead">
    {TOOL_TITLE}
  </h4>
</Block>
<Block width="wide">
  <div class="tool-wrapper">
    <Tabs
      onTabChange={(tab) => {
        if (tab === "map") toolData.mapDataNeeded = true;
      }}
    >
      {#snippet chart()}
        <Chart />
      {/snippet}
      {#snippet map()}
        <Map />
      {/snippet}
    </Tabs>
  </div>
</Block>
<Block>
  <div class="tool-note">
    <p class="note">
      <strong>Source:</strong>
      Urban Institute analysis of Medicaid State Drug Utilization Data from the Centers for Medicare &
      Medicaid Services (CMS); American Community Survey 1-Year Estimates data from the US Census Bureau; CMS
      Performance Indicator Medicaid Enrollment Data; National Survey on Drug Use and Health Small Area
      Estimates from the Substance Abuse and Mental Health Services Administration; Vital Statistics Rapid
      Release Provisional Drug Overdose Death Counts from the National Center for Health Statistics; and
      State Health Access Data Assistance Center analysis of CDC WONDER data. For a description of methods,
      see the accompanying brief.
    </p>
    <p class="note">
      <strong>Notes:</strong> The category of buprenorphine medications that are FDA-approved for treating
      opioid use disorder includes buprenorphine/naloxone. Naloxone is often added to oral/sublingual
      buprenorphine products to deter misuse (e.g., by injection).
    </p>
  </div>
</Block>

<style>
  .tool-note p.note {
    font-size: var(--font-size-sm) !important;
    margin-top: var(--spacing-8);
    margin-bottom: 0 !important;
    line-height: 24px;
  }
  .tool-note p.note:not(:first-of-type) {
    margin-top: 0;
  }
  h4.tool-subhead {
    font-size: 24px !important;
  }
  @media (min-width: 768px) {
    h4.tool-subhead {
      font-size: 28px !important;
    }
  }
</style>
